import { useSession } from '@/auth/SessionProvider';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { ApiProvider } from '@/provider/ApiProvider';
import { canOpenPage } from '@/auth/pageKeys';
import { canEditOthersComments, commentTagsRequired } from '@/utils/userRole';
import * as ConstantMessage from '@/provider/constantmessage';

import { SidebarNavigationContext } from '@/contexts/sidebarNavigationContext';

import default_image from '@/assets/imagePlaceholder.jpeg';

import HeaderFilters from '@/components/shared/HeaderFilters';
import SidebarSettings from '@/components/shared/Sidebar/SidebarSettings';

import validations from '@/utils/validations';
import {
  Autocomplete,
  Avatar,
  Button,
  Card,
  Chip,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  TextareaAutosize,
  Typography,
} from '@mui/material';

import Scrollbars from '@/components/shared/SimpleBarScrollbar';
import Box from '@mui/system/Box';
import 'date-fns';
import serialize from 'form-serialize';
import DownloadLink from 'react-download-link';
import { Link } from 'react-router-dom';

import {
  Clear as ClearIcon,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  DeleteForever as DeleteForeverIcon,
  Edit as EditIcon,
  History as HistoryIcon,
  Search as SearchIcon,
  ThumbDown as ThumbDownIcon,
  ThumbUpOutlined as ThumbUpOutlinedIcon,
} from '@mui/icons-material';
import { getHeaderBrandId } from '@/selection/headerSelection';

const Header = React.forwardRef((...[props]) => {
  const context = useContext(SidebarNavigationContext);
  const { visibilityCompare, updateValue, propertyDetails } = context;

  const { user: userDataInit } = useSession();

  const [userdata] = useState(userDataInit);
  const [, setDisplayActivationFilter] = useState(false);
  const [, setDisplayAdvocayFilter] = useState(false);
  const [, setBrandLogoShow] = useState(false);
  const [, setVisibilityCommentBtn] = useState(true);
  const [visibilityComment, setVisibilityComment] = useState(false);
  const [visibilityAddComment, setVisibilityAddComment] = useState(false);
  const [, setVisibilityEditComment] = useState(false);
  const [visibilityCommentList, setVisibilityCommentList] = useState(true);
  const [visibilityCommentHistory, setVisibilityCommentHistory] = useState(false);
  const [visibilityPropertySelect, setVisibilityPropertySelect] = useState(false);
  const [visibilityBrandSelect, setVisibilityBrandSelect] = useState(false);
  const [visibilityBrandSelectEdit, setVisibilityBrandSelectEdit] = useState(false);
  const [errors, setErrors] = useState({});
  const [CommentsList, setCommentsList] = useState([]);
  const [TagList] = useState([]);
  const [TileList] = useState([]);
  const [media_upload_array, setMediaUploadArray] = useState([]);
  const [tags, setTags] = useState([]);
  const [tiles, setTiles] = useState([]);
  const [keyword_tag, setKeywordTag] = useState([]);
  const [tiles_tag, setTilesTag] = useState([]);
  const [properties_id, setPropertiesId] = useState('');
  const [comment_brand_id, setCommentBrandId] = useState('');
  const [tag_arr, setTagArr] = useState([]);
  useState([]);
  useState([]);
  useState(false);
  useState(false);
  useState(0);
  const [HistoryList, setHistoryList] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [, setGlobalserachkeywordlengthProperty] = useState(0);
  const [, setGlobalserachdataCompair] = useState([]);
  const [globalserachpropertyCompair, setGlobalserachpropertyCompair] = useState([]);
  const [BrandList, setBrandList] = useState([]);
  const [PropertyList, setPropertyList] = useState([]);
  const [property_compair_arr, setPropertyCompairArr] = useState([]);
  const [property_arr] = useState([1, 2, 3, 4, 5]);
  const [property_arr_set, setPropertyArrSet] = useState([]);
  const [brand_arr_set, setBrandArrSet] = useState([]);
  const [proerty_detail_set, setProertyDetailSet] = useState([]);
  const [, setCommentModuleTypeHeader] = useState('');
  const [, setCommentActivationId] = useState('');
  const [, setCommentPropertyId] = useState('');
  const [, setCommentBrandIdState] = useState('');
  const [, setCommentContractId] = useState('');
  const [visibilityPropertySelectEdit, setVisibilityPropertySelectEdit] = useState(false);
  const [visibleCompareOptionsIndex, setVisibleCompareOptionsIndex] = useState(false);
  const [benchmark_show] = useState(false);
  const [BenchmarkGroups] = useState([]);
  const [benchmark_groups_id_arr] = useState(null);
  const [benchmark_groups_id] = useState('');
  const [benchmark_groups_type] = useState('');
  const [, setSelectedBrand] = useState(null);
  const [view_edit_disable] = useState(false);

  // Compare Property search Start

  const get_compair_property_serach = (value, index) => {
    let body = new FormData();
    body.append('term', value);
    body.append('page', '1');
    body.append('type', '1');
    ApiProvider.webservicePostToken('Property/GetPropertyList', body, 'yes').then(
      (response) => {
        if (response.success == true) {
          let fileredItems = response.data.results;
          fileredItems = fileredItems.filter((item) => {
            return item.is_active == 1;
          });
          setGlobalserachdataCompair(fileredItems);
          setGlobalserachpropertyCompair(fileredItems);
          for (let element of document.getElementsByClassName('floatingsearchresult')) {
            element.style.display = 'none';
          }

          if (document.getElementById('search_div_show' + index) != null) {
            document.getElementById('search_div_show' + index).style.display = 'block';
          }
        } else {
          setGlobalserachdataCompair([]);
          setGlobalserachpropertyCompair([]);
          for (let element of document.getElementsByClassName('floatingsearchresult')) {
            element.style.display = 'none';
          }
        }
      },
      (error) => {
        setGlobalserachdataCompair([]);
        setGlobalserachpropertyCompair([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const handleKeyUpProperty = (event, value, index) => {
    var keyupvalue = event.target.value;
    setGlobalserachkeywordlengthProperty(keyupvalue.length);
    if (keyupvalue.length > 2) {
      get_compair_property_serach(keyupvalue, index);
    } else {
      setGlobalserachdataCompair([]);
      setGlobalserachpropertyCompair([]);
      for (let element of document.getElementsByClassName('floatingsearchresult')) {
        element.style.display = 'none';
      }
    }
  };

  const setPropertyCompair = (row, index) => {
    // Check if property already exists in array
    const index1 = property_compair_arr.findIndex((obj) => obj.id === row.id);

    if (index1 >= 0) {
      ApiProvider.globalToastMessage(ConstantMessage.error_same_property_select, 5000, 'error');
      return false;
    }

    setPropertyCompairArr((prev) => [...prev, row]);
    setGlobalserachkeywordlengthProperty([]);
    setGlobalserachpropertyCompair([]);

    const searchEl = document.getElementById('search_hide' + index);
    const selectedEl = document.getElementById('selected_data' + index);

    if (searchEl && selectedEl) {
      searchEl.style.display = 'none';
      selectedEl.style.display = 'block';

      const nameEl = document.getElementById('full_name_set' + index);
      const imgEl = document.getElementById('image_set' + index);
      const categoryEl = document.getElementById('category_set' + index);
      const typeEl = document.getElementById('property_type_set' + index);

      if (nameEl) nameEl.innerHTML = row.full_name;
      if (imgEl) imgEl.src = row.profile_img;
      if (categoryEl) categoryEl.innerHTML = row.category_name;
      if (typeEl) typeEl.innerHTML = row.property_type;
    }
  };

  const removePropertyCompair = (index) => {
    var array = [...property_compair_arr];
    array.splice(index, 1);
    setPropertyCompairArr(array);
    document.getElementById('search_hide' + index).style.display = 'block';
    document.getElementById('selected_data' + index).style.display = 'none';
    document.getElementById('full_name_set' + index).innerHTML = '';
    document.getElementById('image_set' + index).src = '';
    document.getElementById('category_set' + index).innerHTML = '';
    document.getElementById('property_type_set' + index).innerHTML = '';
    document.getElementById('remove_search_value' + index).value = '';
  };

  const compairProperty = () => {
    localStorage.setItem('ComparePropertySearch', JSON.stringify(property_compair_arr));
  };

  const GetPropertyDetails = (property_id) => {
    let body = new FormData();
    body.append('property_id[]', property_id);
    body.append('type', 2);
    ApiProvider.webservicePostToken('Property/GetPropertyList', body, 'yes').then(
      (response) => {
        if (response.success == true) {
          if (response.data.results.length > 0) {
            setProertyDetailSet(response.data.results);
            setPropertyCompairArr((prev) => [...prev, response.data.results[0]]);
            setGlobalserachkeywordlengthProperty([]);
            setGlobalserachpropertyCompair([]);
          }
        }
      },
      (error) => {
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  //Property search end

  const getDataFromURL = (url) =>
    new Promise((resolve) => {
      setTimeout(() => {
        fetch(url, { mode: 'no-cors' })
          .then((response) => response.text())
          .then((data) => {
            resolve(data);
          });
      });
    }, 2000);

  const handleToggleVisibilityComment = () => {
    setVisibilityComment((prev) => !prev);
  };

  const handleToggleVisibilityAddComment = () => {
    let newErrors = {};
    newErrors['comments'] = '';
    newErrors['tags'] = '';
    newErrors['tiles'] = '';
    newErrors['properties_id'] = '';
    newErrors['comment_brand_id'] = '';
    setErrors(newErrors);
    setTags([]);
    setKeywordTag([]);
    setTilesTag([]);
    setMediaUploadArray([]);
    setPropertyArrSet([]);
    setBrandArrSet([]);
    setPropertiesId('');
    setCommentBrandId('');
    setTiles([]);
    for (let element of document.getElementsByClassName('comment_list_div')) {
      element.style.display = 'block';
    }

    for (let element of document.getElementsByClassName('comment_edit_div')) {
      element.style.display = 'none';
    }

    setVisibilityAddComment((prev) => !prev);
  };

  const hideVisibilityCommentHistory = () => {
    setVisibilityCommentHistory(false);
    setVisibilityCommentList(true);
  };

  const GetBrandList = (value, brandIdParam) => {
    ApiProvider.webserviceGet('Brands/GetBrands').then(
      (response) => {
        if (response.success == true) {
          setBrandList(response.data.results);
          if (brandIdParam > 0) {
            setTimeout(() => {
              setBrandArrSet(response.data.results[0]);
            }, 500);
          }
        } else {
          setBrandList([]);
        }
      },
      (error) => {
        setBrandList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const GetPropertyList = (value, property_id) => {
    var property_id_arr = [];
    let body = new FormData();
    body.append('flag', 'active');
    body.append('page', '1');
    body.append('term', value);
    if (property_id > 0) {
      property_id_arr.push(property_id);
      body.append('property_id[]', property_id_arr);
    }

    ApiProvider.webservicePostToken('Property/GetPropertyList', body, 'yes').then(
      (response) => {
        if (response.success == true) {
          setPropertyList(response.data.results);
          if (property_id > 0) {
            setTimeout(() => {
              setPropertyArrSet(response.data.results[0]);
            }, 500);
          }
        } else {
          setPropertyList([]);
        }

        setPropertiesId('');
        setPropertyArrSet([]);
      },
      (error) => {
        setPropertyList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const CommentLikeDislike = (comment_id, flag) => {
    const user_id = userdata.id;
    let body = new FormData();
    body.append('user_id', user_id);
    body.append('comment_id', comment_id);
    body.append('type', flag);
    if (props.module_type == 7) {
      if (props.brand_id != undefined) {
        body.append('brand_id', props.brand_id);
      } else {
        body.append('brand_id', 0);
      }
    }

    if (props.module_type == 8) {
      if (props.property_id != undefined) {
        body.append('property_id', props.property_id);
      } else {
        body.append('property_id', 0);
      }
    }

    if (props.module_type == 15) {
      if (props.contract_id != undefined) {
        body.append('contract_id', props.contract_id);
      } else {
        body.append('contract_id', 0);
      }
    }

    if (props.module_type == 11) {
      if (props.activation_id != undefined) {
        body.append('activation_id', props.activation_id);
      } else {
        body.append('activation_id', 0);
      }
    }

    ApiProvider.webserviceGet(
      'Comments/LikeDislike?user_id=' +
        user_id +
        '&comment_id=' +
        comment_id +
        '&type=' +
        flag +
        '',
    ).then(
      (response) => {
        if (response.success == true) {
          document.getElementById('comment_like_count' + comment_id).innerHTML =
            response.data.likes;
          document.getElementById('comment_dislike_count' + comment_id).innerHTML =
            response.data.dislikes;
        }
      },
      (error) => {
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const CommentHistory = (comment_id) => {
    const user_id = userdata.id;
    let body = new FormData();
    body.append('user_id', user_id);
    body.append('comment_id', comment_id);
    if (props.module_type == 7) {
      if (props.brand_id != undefined) {
        body.append('brand_id', props.brand_id);
      } else {
        body.append('brand_id', 0);
      }
    }

    if (props.module_type == 8) {
      if (props.property_id != undefined) {
        body.append('property_id', props.property_id);
      } else {
        body.append('property_id', 0);
      }
    }

    if (props.module_type == 15) {
      if (props.contract_id != undefined) {
        body.append('contract_id', props.contract_id);
      } else {
        body.append('contract_id', 0);
      }
    }

    if (props.module_type == 11) {
      if (props.activation_id != undefined) {
        body.append('activation_id', props.activation_id);
      } else {
        body.append('activation_id', 0);
      }
    }

    ApiProvider.webserviceGet(
      'Comments/CommentHistory?user_id=' + user_id + '&comment_id=' + comment_id,
    ).then(
      (response) => {
        if (response.success == true) {
          setVisibilityCommentList(false);
          setVisibilityCommentHistory(true);
          setHistoryList(response.data.results);
        } else {
          setHistoryList([]);
        }
      },
      (error) => {
        setHistoryList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const TagChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        var arr = [];
        var check_property = 'no';
        var check_brand = 'no';
        value.forEach((key_get) => {
          arr.push(key_get.id);
          if (key_get.id == 1 || key_get.id == 5) {
            check_property = 'yes';
          }

          if (key_get.id == 2 || key_get.id == 5) {
            check_brand = 'yes';
          }

          setTags(JSON.stringify(arr));
        });

        if (check_property == 'yes' && props.property_id == undefined) {
          setVisibilityPropertySelect(true);
        } else {
          setVisibilityPropertySelect(false);
        }

        if (check_brand == 'yes' && props.brand_id == undefined) {
          setVisibilityBrandSelect(true);
        } else {
          setVisibilityBrandSelect(false);
        }
      } else {
        setTags([]);
        setVisibilityPropertySelect(false);
        setVisibilityBrandSelect(false);
      }
    } else {
      setTags([]);
      setVisibilityPropertySelect(false);
      setVisibilityBrandSelect(false);
    }
  };

  //------------tile change------------------
  const TileChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        var arr = [];
        value.forEach((key_get) => {
          arr.push(key_get.id);
          setTiles(JSON.stringify(arr));
        });
      } else {
        setTiles([]);
      }
    } else {
      setTiles([]);
    }
  };

  const PropertyChange = (event, value) => {
    if (value != null) {
      setPropertiesId(value.id);
    } else {
      setPropertiesId('');
    }
  };

  const TagEditChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        var arr = [];
        var arr1 = [];
        var check_property = 'no';
        var check_brand = 'no';
        value.forEach((key_get) => {
          var index = TagList.findIndex((obj) => obj.id == key_get.id);
          if (key_get.id == 1 || key_get.id == 5) {
            check_property = 'yes';
          }
          if (key_get.id == 2 || key_get.id == 5) {
            check_brand = 'yes';
          }
          arr1.push(key_get.id);
          if (index >= 0) {
            arr.push(TagList[index]);
          }

          setTagArr(arr);
          setTags(JSON.stringify(arr1));
          if (check_property == 'yes' && props.property_id == undefined) {
            setVisibilityPropertySelectEdit(true);
          } else {
            setVisibilityPropertySelectEdit(false);
          }

          if (check_brand == 'yes' && props.brand_id == undefined) {
            setVisibilityBrandSelectEdit(true);
          } else {
            setVisibilityBrandSelectEdit(false);
          }
        });
      } else {
        setTags([]);
        setTagArr([]);
        setVisibilityPropertySelectEdit(false);
        setVisibilityBrandSelectEdit(false);
      }
    } else {
      setTags([]);
      setTagArr([]);
      setVisibilityPropertySelectEdit(false);
      setVisibilityBrandSelectEdit(false);
    }
  };

  const PropertyChangeEdit = (event, value) => {
    if (value != null) {
      setPropertyArrSet(value);
      setPropertiesId(value.id);
    } else {
      setPropertiesId('');
      setPropertyArrSet([]);
    }
  };

  const CommentBrandListChange = (event, value) => {
    if (value != null) {
      setCommentBrandId(value.id);
      let newErrors = errors;
      newErrors['comment_brand_id'] = '';
      setErrors(newErrors);
    } else {
      setCommentBrandId('');
    }
  };

  const CommentBrandListChangeEdit = (event, value) => {
    if (value != null) {
      setCommentBrandId(value.id);
      let newErrors = errors;
      newErrors['comment_brand_id'] = '';
      setErrors(newErrors);
    } else {
      setCommentBrandId('');
    }
  };

  const TileChangeEdit = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        var arr = [];
        var arr1 = [];
        value.forEach((key_get) => {
          var index = TileList.findIndex((obj) => obj.id == key_get.id);
          arr1.push(key_get.id);
          if (index >= 0) {
            arr.push(TileList[index]);
          }

          setTilesTag(arr);
          setTiles(JSON.stringify(arr1));
        });
      }
    } else {
      setTilesTag([]);
    }
  };

  const validate = (obj) => {
    let newErrors = {};
    let isValid = true;
    if (!obj.comments) {
      isValid = false;
      newErrors['comments'] = ConstantMessage.error_comment;
    } else {
      if (!validations.validateAlphaNumeric(obj.comments)) {
        isValid = false;
        newErrors['comments'] = ConstantMessage.error_description_validation;
      } else if (obj.comments.length > 500) {
        isValid = false;
        newErrors['comments'] = ConstantMessage.error_description_length_validation;
      } else {
        newErrors['comments'] = '';
      }
    }

    // Internal contexts tag their comments (was: role id 11 in the stored `userRole` list).
    if (commentTagsRequired()) {
      if (!obj.keyword_tag && !obj.tags) {
        isValid = false;
        newErrors['tags'] = ConstantMessage.error_tag_select;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    var form = document.querySelector('#addcomment');
    var obj = serialize(form, { hash: true });

    if (validate(obj)) {
      setSubmitted(true);
      const user_id = userdata.id;
      let body = new FormData();
      body.append('user_id', user_id);
      body.append('comments', obj.comments);
      body.append('module_type', props.module_type);
      if (props.module_type == 7) {
        if (props.brand_id != undefined) {
          body.append('brand_id', props.brand_id);
        }
      }

      if (props.module_type == 8) {
        if (props.property_id != undefined) {
          body.append('property_id', props.property_id);
        }
      }

      if (props.module_type == 15) {
        if (props.contract_id != undefined) {
          body.append('contract_id', props.contract_id);
        } else {
          body.append('contract_id', 0);
        }
      }

      if (props.module_type == 11) {
        if (props.activation_id != undefined) {
          body.append('activation_id', props.activation_id);
        } else {
          body.append('activation_id', 0);
        }
      }

      if (obj.tags != undefined) {
        var check_property = 'no';
        var check_brand = 'no';
        let tagsLocal = JSON.parse(obj.tags);
        tagsLocal.forEach((key_get) => {
          body.append('tags[]', key_get);
          if (key_get == 1 || key_get == 5) {
            check_property = 'yes';
          }
          if (key_get == 2 || key_get == 5) {
            check_brand = 'yes';
          }
        });

        if (check_property == 'yes' && props.property_id == undefined) {
          body.append('property_id', obj.properties_id);
        }
        if (check_brand == 'yes' && props.brand_id == undefined) {
          body.append('brand_id', obj.brand_id);
        }
      }

      if (obj.tiles != undefined) {
        let tilesLocal = JSON.parse(obj.tiles);
        tilesLocal.forEach((key_get) => {
          body.append('tile_ids[]', key_get);
        });
      }

      if (keyword_tag.length > 0) {
        var arr = [];
        keyword_tag.forEach((key_get) => {
          arr.push(key_get.name);
        });

        body.append('keyword_tag', arr.join());
      }

      if (media_upload_array.length > 0) {
        media_upload_array.forEach((value_get, key) => {
          body.append('document_file[' + key + '][file_s3_key]', value_get.file_s3_key);
          body.append('document_file[' + key + '][media_id]', value_get.media_id);
        });
      }

      ApiProvider.webservicePostToken('Comments/AddComment', body, 'yes').then(
        (response) => {
          if (response.success == true) {
            setMediaUploadArray([]);
            setTags([]);
            setVisibilityAddComment(false);
            setKeywordTag([]);
            setTilesTag([]);
            setVisibilityPropertySelect(false);
            setVisibilityBrandSelect(false);
            setVisibilityPropertySelectEdit(false);
            setVisibilityBrandSelectEdit(false);
            var terms = '';
            GetPropertyList(terms, 0);
            GetBrandList(terms, 0);
            ApiProvider.globalToastMessage(response.message, 5000, 'success');
            var arr = CommentsList;
            if (response.data) {
              arr.push(response.data.results);
              setCommentsList(arr);
            }

            setSubmitted(false);
          } else {
            setSubmitted(false);
            ApiProvider.globalApiErrorMessage(response.message);
            return;
          }
        },
        (error) => {
          ApiProvider.globalToastMessage(error, 5000, 'error');
          return;
        },
      );
    }
  };

  const handleUpdate = (comment_id) => {
    var form = document.querySelector('#editcomment' + comment_id);
    var obj = serialize(form, { hash: true });

    if (validate(obj)) {
      setSubmitted(true);
      const user_id = userdata.id;
      var object = {};
      let body = new FormData();
      body.append('user_id', user_id);
      body.append('comments', obj.comments);
      body.append('comment_id', comment_id);
      body.append('module_type', props.module_type);
      if (props.module_type == 7) {
        if (props.brand_id != undefined) {
          body.append('brand_id', props.brand_id);
        } else {
          body.append('brand_id', 0);
        }
      }

      if (props.module_type == 8) {
        if (props.property_id != undefined) {
          body.append('property_id', props.property_id);
        } else {
          body.append('property_id', 0);
        }
      }

      if (props.module_type == 15) {
        if (props.contract_id != undefined) {
          body.append('contract_id', props.contract_id);
        } else {
          body.append('contract_id', 0);
        }
      }

      if (props.module_type == 11) {
        if (props.activation_id != undefined) {
          body.append('activation_id', props.activation_id);
        } else {
          body.append('activation_id', 0);
        }
      }

      if (obj.tags != undefined) {
        var check_property = 'no';
        let tagsLocal = JSON.parse(obj.tags);
        tagsLocal.forEach((key_get) => {
          body.append('tags[]', key_get);
          if (key_get == 1) {
            check_property = 'yes';
          }
        });

        if (check_property == 'yes' && props.property_id == undefined) {
          body.append('property_id', obj.properties_id);
        } else {
          if (props.module_type != 8) {
            body.append('property_id', 0);
          }
        }
      }

      if (keyword_tag.length > 0) {
        var arr = [];
        keyword_tag.forEach((key_get) => {
          arr.push(key_get.name);
        });

        body.append('keyword_tag', arr.join());
      }

      if (media_upload_array.length > 0) {
        media_upload_array.forEach((value_get, key) => {
          body.append('document_file[' + key + '][file_s3_key]', value_get.file_s3_key);
          body.append('document_file[' + key + '][media_id]', value_get.media_id);
        });
      }

      body.forEach(function (value, key) {
        object[key] = value;
      });
      ApiProvider.webservicePostToken('Comments/UpdateComment', body, 'yes').then(
        (response) => {
          if (response.success == true) {
            document.getElementById('comment_list_div' + comment_id).style.display = 'block';
            document.getElementById('comment_edit_div' + comment_id).style.display = 'none';
            setMediaUploadArray([]);
            setTags([]);
            setVisibilityEditComment(false);
            setKeywordTag([]);
            setTilesTag([]);
            setVisibilityBrandSelect(false);
            setVisibilityPropertySelect(false);
            setVisibilityPropertySelectEdit(false);
            setVisibilityBrandSelectEdit(false);
            var terms = '';
            GetPropertyList(terms, 0);
            GetBrandList(terms, 0);
            var arr = CommentsList;
            if (response.data) {
              var index = arr.findIndex((obj2) => obj2.id == parseInt(comment_id));

              if (index >= 0) {
                arr[index].comments = response.data.results.comments;
                arr[index].files = response.data.results.files;
                arr[index].keywordTag = response.data.results.keywordTag;
                arr[index].tagsArea = response.data.results.tagsArea;
                arr[index].totalDisLikes = response.data.results.totalDisLikes;
                arr[index].totalLikes = response.data.results.totalLikes;
                arr[index].property_id = response.data.results.property_id;
              }

              setCommentsList(arr);
            }

            setSubmitted(false);
          } else {
            setSubmitted(false);
            ApiProvider.globalApiErrorMessage(response.message);
            return;
          }
        },
        (error) => {
          ApiProvider.globalToastMessage(error, 5000, 'error');
          return;
        },
      );
    }
  };

  const handleCaptureMedia = (event) => {
    new FileReader();
    let file = event.target.files[0];
    const user_id = userdata.id;
    if (event.target.files[0] != undefined) {
      var file_name = event.target.files[0].name;
      var extension = file_name.split('.').pop();
      var accepted_arr = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png', 'gif', 'svg'];
      var accept_status = accepted_arr.filter((item) => item == extension);
      if (accept_status.length <= 0) {
        ApiProvider.globalToastMessage(
          ConstantMessage.error_file_accepted + accepted_arr.join(),
          5000,
          'error',
        );
        return false;
      }

      let body = new FormData();
      body.append('uploaded_file', file);
      body.append('user_id', user_id);
      body.append('folder_name', 'media');
      ApiProvider.webservicePostToken('Medias/UploadMedia', body, 'yes').then(
        (response) => {
          if (response.success == true) {
            setMediaUploadArray((prev) => {
              const row = response.data[0];
              var extension2 = file_name.split('.').pop();
              row.file_name = file_name;
              row.extension = extension2;
              var accepted_arr2 = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
              var accept_status2 = accepted_arr2.filter((item) => item == extension2);
              row.file_type = 'other';
              if (accept_status2.length > 0) {
                row.file_type = 'image';
              }

              return [...prev, row];
            });
          } else {
            ApiProvider.globalApiErrorMessage(response.message);
            return;
          }
        },
        (error) => {
          ApiProvider.globalToastMessage(error, 5000, 'error');
          return;
        },
      );
    }
  };

  const handleMediaDelete = (index) => {
    ApiProvider.webservicePostTokenDelete(
      'Medias/DeleteMedia/' + media_upload_array[index].media_id,
    ).then(
      (response) => {
        if (response.success == true) {
          var array = [...media_upload_array];
          array.splice(index, 1);
          setMediaUploadArray(array);
        } else {
          ApiProvider.globalApiErrorMessage(response.message);
          return;
        }
      },
      (error) => {
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const _handleKeyDown = (e) => {
    if (e.key == 'Enter') {
      setKeywordTag((prev) => [...prev, { name: e.target.value }]);
    }
  };

  const DeleteTag = (index) => {
    var array = [...keyword_tag];
    array.splice(index, 1);
    setKeywordTag(array);
  };

  const visibilityEditCommentCancel = (id) => {
    document.getElementById('comment_list_div' + id).style.display = 'block';
    document.getElementById('comment_edit_div' + id).style.display = 'none';
  };

  const EditTag = (id) => {
    let terms = null;

    let newErrors = {};
    newErrors['comments'] = '';
    newErrors['tags'] = '';
    newErrors['properties_id'] = '';
    newErrors['comment_brand_id'] = '';
    setErrors(newErrors);
    setErrors(newErrors);
    for (let element of document.getElementsByClassName('comment_list_div')) {
      element.style.display = 'block';
    }

    for (let element of document.getElementsByClassName('comment_edit_div')) {
      element.style.display = 'none';
    }

    setVisibilityAddComment(false);
    var index = CommentsList.findIndex((obj) => obj.id == id);

    setVisibilityEditComment(false);
    if (index >= 0) {
      var comment_data = CommentsList[index];
      var tagsArea = comment_data.tagsArea;
      var keywordTag2 = comment_data.keywordTag;
      var tilesArr = comment_data.tiles;
      if (tagsArea.length > 0) {
        const arr = [];
        const arr1 = [];
        var check_property = 'no';
        var check_brand = 'no';
        tagsArea.forEach((key_get) => {
          var id_get = key_get;
          var idx = TagList.findIndex((obj) => obj.name == id_get);
          if (idx >= 0) {
            var id2 = TagList[idx].id;
            if (id2 == 1 || id2 == 5) {
              check_property = 'yes';
            }
            if (id2 == 2 || id2 == 5) {
              check_brand = 'yes';
            }

            arr1.push(id2);
            arr.push(TagList[idx]);
          }

          setTagArr(arr);
        });

        if (check_property == 'yes' && props.property_id == undefined) {
          setVisibilityPropertySelectEdit(true);
          terms = '';
          GetPropertyList(terms, comment_data.property_id);
          setPropertiesId(comment_data.property_id);
        } else if (check_brand == 'yes' && props.brand_id == undefined) {
          setVisibilityBrandSelectEdit(true);
          terms = '';
          GetBrandList(terms, comment_data.brand_id);
          setCommentBrandId(comment_data.brand_id);
        } else {
          setVisibilityPropertySelectEdit(false);
          setPropertyArrSet([]);
          setBrandArrSet([]);
          setPropertiesId('');
        }

        setTags(JSON.stringify(arr1));
      } else {
        setVisibilityPropertySelectEdit(false);
        setPropertyArrSet([]);
        setBrandArrSet([]);
        setPropertiesId('');
      }

      if (keywordTag2.length > 0) {
        const arr = [];
        keywordTag2.forEach((key_get) => {
          var json = {
            name: key_get,
          };
          arr.push(json);
        });

        setKeywordTag(arr);
      }
      //------------------tiles---------------

      if (tilesArr.length > 0) {
        const arr = [];
        const arr1 = [];
        tilesArr.forEach((key_get) => {
          var id_get = key_get;
          var idx = TileList.findIndex((obj) => obj.name == id_get);
          if (idx >= 0) {
            arr1.push(idx);
            arr.push(TileList[idx]);
          }

          setTilesTag(arr);
        });
      }

      var files = comment_data.files;
      if (files.length > 0) {
        var new_arr = [];
        files.forEach((key_get) => {
          var old_data = key_get;
          var extension = old_data.name.split('.').pop();
          old_data.extension = extension;
          var accepted_arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
          var accept_status = accepted_arr.filter((item) => item == extension);

          var file_type_set = 'other';
          if (accept_status.length > 0) {
            file_type_set = 'image';
          }

          old_data.file_type = file_type_set;

          new_arr.push(old_data);
        });

        setMediaUploadArray(new_arr);
      } else {
        setMediaUploadArray(files);
      }

      document.getElementById('comment_list_div' + id).style.display = 'none';
      document.getElementById('comment_edit_div' + id).style.display = 'block';
    }
  };

  const BrandBenchmarkGroupsChange = () => {};

  useEffect(() => {
    // the page to return to is noted per role by auth/RolePageRecorder.tsx (not here: this
    // header also mounts while a role switch loads the next role under the previous page)
    const intervalId = setInterval(() => {
      const displayActivationFilterElement = document.getElementById('displayActivationFilter');
      const displayAdvocacyFilterElement = document.getElementById('displayAdvocayFilter');

      const newActivation = displayActivationFilterElement ? true : false;
      const newAdvocay = displayAdvocacyFilterElement ? true : false;

      setDisplayActivationFilter((prev) => (prev !== newActivation ? newActivation : prev));
      setDisplayAdvocayFilter((prev) => (prev !== newAdvocay ? newAdvocay : prev));
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // Replicate componentDidUpdate logic with useEffect dependencies
  useEffect(() => {
    const isPropertyDetailsEmpty = !Object.keys(propertyDetails).length;
    const isStatePropertyDetailsEmpty = !proerty_detail_set.length;

    if (!isStatePropertyDetailsEmpty && isPropertyDetailsEmpty) {
      const { full_name, profile_img, category_name, property_type } = proerty_detail_set[0];
      updateValue('propertyDetails', { full_name, profile_img, category_name, property_type });
    } else if (isStatePropertyDetailsEmpty && !isPropertyDetailsEmpty) {
      updateValue('propertyDetails', {});
    }
  });

  const prevModuleTypeRef = useRef();
  useEffect(() => {
    if (prevModuleTypeRef.current === props.module_type) {
      return;
    }
    prevModuleTypeRef.current = props.module_type;
    setSelectedBrand(getHeaderBrandId());
    setCommentModuleTypeHeader(props.module_type);
    if (props.property_id != undefined) {
      GetPropertyDetails(props.property_id);
      setCommentPropertyId(props.property_id);
    }
  }, [props.module_type]);

  const prevContractIdRef = useRef();
  useEffect(() => {
    if (prevContractIdRef.current === props.contract_id) {
      return;
    }
    prevContractIdRef.current = props.contract_id;
    setCommentContractId(props.contract_id);
  }, [props.contract_id]);

  const prevActivationIdRef = useRef();
  useEffect(() => {
    if (prevActivationIdRef.current === props.activation_id) {
      return;
    }
    prevActivationIdRef.current = props.activation_id;
    setCommentActivationId(props.contract_id);
  }, [props.activation_id, props.contract_id]);

  const prevBrandIdRef = useRef();
  useEffect(() => {
    if (prevBrandIdRef.current === props.brand_id) {
      return;
    }
    prevBrandIdRef.current = props.brand_id;
    setCommentBrandIdState(props.brand_id);
  }, [props.brand_id]);

  const prevPropertyIdRef = useRef();
  useEffect(() => {
    if (prevPropertyIdRef.current === props.property_id) {
      return;
    }
    prevPropertyIdRef.current = props.property_id;
    setCommentPropertyId(props.property_id);
  }, [props.property_id]);

  const prevBrandLogoShowRef = useRef();
  useEffect(() => {
    if (prevBrandLogoShowRef.current === props.brand_logo_show) {
      return;
    }
    prevBrandLogoShowRef.current = props.brand_logo_show;
    setBrandLogoShow(!!props.brand_logo_show);
  }, [props.brand_logo_show]);

  const prevCampairSearchRef = useRef();
  useEffect(() => {
    if (prevCampairSearchRef.current === props.campair_search) {
      return;
    }
    prevCampairSearchRef.current = props.campair_search;
    setVisibilityCommentBtn(false);
  }, [props.campair_search]);

  const prevCommentHideRef = useRef();
  useEffect(() => {
    if (prevCommentHideRef.current === props.comment_hide) {
      return;
    }
    prevCommentHideRef.current = props.comment_hide;
    setVisibilityCommentBtn(false);
  }, [props.comment_hide]);

  return (
    <header className={`header-section ${props.className || ''}`} style={props.style}>
      <HeaderFilters bendchmarkDisplay={benchmark_show} bendchmarkList={BenchmarkGroups} />
      <div
        style={{
          paddingLeft: '2.5rem',
          paddingRight: '2.5rem',
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Grid container alignItems='center' spacing={2}>
          <Grid
            className='flex_center'
            size={{
              lg: 3,
              md: 4,
              xs: 12,
              sm: 6,
            }}
          >
            <div className='flex' style={{ flex: 1 }}>
              {benchmark_show == true ? (
                <div className='w-45' style={{ marginLeft: '16px' }}>
                  <Autocomplete
                    id='brand_benchmark_groups_id'
                    className='header_search'
                    size='small'
                    value={benchmark_groups_id_arr}
                    options={BenchmarkGroups ? BenchmarkGroups : []}
                    onChange={BrandBenchmarkGroupsChange}
                    getOptionLabel={(option) => (option ? option.benchmark_name : '')}
                    renderInput={(params) => (
                      <TextField {...params} label='Benchmark' variant='outlined' />
                    )}
                  />
                  <input
                    type='text'
                    name='benchmark_groups_id'
                    id='benchmark_groups_id'
                    value={benchmark_groups_id}
                    readOnly
                    hidden
                  />
                  <input
                    type='text'
                    name='benchmark_groups_type'
                    id='benchmark_groups_type'
                    readOnly
                    value={benchmark_groups_type}
                    hidden
                  />
                </div>
              ) : (
                ''
              )}
            </div>
          </Grid>
          <SidebarSettings />
        </Grid>
      </div>
      {visibilityComment && (
        <div
          style={{
            position: 'fixed',
            width: '100%',
            height: '100vh',
            top: '0',
          }}
          onClick={handleToggleVisibilityComment}
        ></div>
      )}
      {visibilityComment && (
        <div className='comment_section'>
          <div className='apply_radius_incard relative_div'>
            <Card>
              <div className='card_content comment_blog_min_height box_shadow'>
                <Typography variant='h4' color='secondary'>
                  Comments
                </Typography>
                <div className='close_commentbox' onClick={handleToggleVisibilityComment}>
                  <CloseIcon color='secondary' />
                </div>

                <Scrollbars
                  className={visibilityAddComment == true ? 'comment_form_blog' : 'comment_block'}
                  id='comment_list'
                >
                  <List>
                    {visibilityCommentList &&
                      CommentsList.map((data, key) => (
                        <div key={key} className='comment_card box_shadow nopadding relative_div'>
                          <div id={`comment_list_div${data.id}`} className='comment_list_div'>
                            <ListItem alignItems='flex-start'>
                              {(Boolean(userdata.id == data.user_id) ||
                                canEditOthersComments()) && (
                                <div className='cedit'>
                                  <EditIcon onClick={() => EditTag(data.id)} />
                                </div>
                              )}

                              <ListItemText
                                className='comment_content comment_username'
                                primary={data.name}
                                secondary={data.comments}
                              />
                            </ListItem>

                            {data.files.map((data_get, key) => (
                              <div key={key} className='comment_share_section'>
                                <DownloadLink
                                  className='font_small'
                                  label={data_get.name}
                                  filename={data_get.name}
                                  exportFile={() =>
                                    Promise.resolve(getDataFromURL(data_get.file_path))
                                  }
                                />
                              </div>
                            ))}

                            <ListItem
                              alignItems='flex-start'
                              style={{ display: 'block', paddingRight: '0px' }}
                            >
                              <Scrollbars style={{ width: 250, height: 70, overflowY: 'hidden' }}>
                                {data.tagsArea.map((tag_name, key) => (
                                  <Chip
                                    key={key}
                                    className='font_small'
                                    label={tag_name}
                                    style={{ margin: '3px' }}
                                  />
                                ))}

                                {data.keywordTag.map((tag_new_name, key) => (
                                  <Chip
                                    key={key}
                                    className='font_small'
                                    label={tag_new_name}
                                    style={{ margin: '3px' }}
                                  />
                                ))}

                                {data.tiles.map((tiles_name, key) => (
                                  <Chip
                                    key={key}
                                    className='font_small'
                                    label={tiles_name}
                                    style={{ margin: '3px' }}
                                  />
                                ))}

                                {Boolean(Object.keys(data.property_data).length > 0) && (
                                  <Chip
                                    className='font_small'
                                    label={data.property_data.name}
                                    style={{ margin: '3px' }}
                                  />
                                )}

                                {Boolean(Object.keys(data.brand_data).length > 0) && (
                                  <Chip
                                    className='font_small'
                                    label={data.brand_data.name}
                                    style={{ margin: '3px' }}
                                  />
                                )}
                              </Scrollbars>
                            </ListItem>

                            <div className='comment_share_section flex margin_top3'>
                              <Typography
                                className='comment_date'
                                variant='caption'
                                color='textSecondary'
                                component='div'
                              >
                                {data.date}
                              </Typography>
                              <div className='text_right comment_icon'>
                                <div className='font_small'>
                                  <ThumbUpOutlinedIcon
                                    fontSize='small'
                                    onClick={() => CommentLikeDislike(data.id, 'like')}
                                  />
                                  <div id={`comment_like_count${data.id}`}>{data.totalLikes}</div>
                                </div>
                                <div className='font_small'>
                                  <ThumbDownIcon
                                    fontSize='small'
                                    onClick={() => CommentLikeDislike(data.id, 'dislike')}
                                  />
                                  <div id={`comment_dislike_count${data.id}`}>
                                    {data.totalDisLikes}
                                  </div>
                                </div>
                                <div className='font_small'>
                                  <HistoryIcon
                                    fontSize='small'
                                    onClick={() => CommentHistory(data.id)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className='edit_form comment_edit_div'
                            style={{ display: 'none' }}
                            id={`comment_edit_div${data.id}`}
                          >
                            <form
                              id={`editcomment${data.id}`}
                              encType='multipart/form-data'
                              autoComplete='off'
                            >
                              <div className='comment_card box_shadow nopadding relative_div'>
                                <ListItem alignItems='flex-start' style={{ flexWrap: 'wrap' }}>
                                  <Grid container spacing={1}>
                                    <Grid
                                      size={{
                                        lg: 12,
                                      }}
                                    >
                                      <TextareaAutosize
                                        style={{
                                          width: '88%',
                                          background: 'transparent',
                                          marginTop: '0.5rem',
                                        }}
                                        name='comments'
                                        className='custom_textarea'
                                        aria-label='minimum height'
                                        defaultValue={data.comments}
                                        minRows={2}
                                        placeholder='Comments *'
                                      />
                                      <input
                                        type='text'
                                        name='comment_id'
                                        value={data.id}
                                        readOnly
                                        hidden
                                      />
                                      <div className='invalid-feedback'>{errors.comments}</div>
                                    </Grid>
                                    <Grid
                                      size={{
                                        lg: 12,
                                      }}
                                    >
                                      <Autocomplete
                                        multiple
                                        id='tags'
                                        className='full-width'
                                        value={tag_arr}
                                        onChange={TagEditChange}
                                        options={TagList ? TagList : []}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            onKeyDown={_handleKeyDown}
                                            label='Tags'
                                            variant='outlined'
                                          />
                                        )}
                                      />
                                      <div className='invalid-feedback'>{errors.tags}</div>
                                      <input type='text' name='tags' value={tags} readOnly hidden />

                                      {keyword_tag.map((row, i) => (
                                        <Chip
                                          key={i}
                                          label={row.name}
                                          deletevalue={i}
                                          onDelete={() => DeleteTag(i)}
                                        />
                                      ))}
                                    </Grid>
                                    {/* tiles */}
                                    <Grid
                                      size={{
                                        lg: 12,
                                      }}
                                    >
                                      <Autocomplete
                                        multiple
                                        id='tiles_edit'
                                        className='full-width'
                                        value={tiles_tag}
                                        onChange={TileChangeEdit}
                                        options={TileList ? TileList : []}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            onKeyDown={_handleKeyDown}
                                            label='Tiles'
                                            variant='outlined'
                                          />
                                        )}
                                      />
                                      <div className='invalid-feedback'>{errors.tiles}</div>
                                      <input
                                        type='text'
                                        name='tiles'
                                        value={tiles}
                                        readOnly
                                        hidden
                                      />
                                    </Grid>

                                    {visibilityPropertySelectEdit && (
                                      <Grid
                                        size={{
                                          lg: 12,
                                        }}
                                      >
                                        <Autocomplete
                                          id='property'
                                          className='full-width'
                                          value={property_arr_set}
                                          onChange={PropertyChangeEdit}
                                          options={PropertyList ? PropertyList : []}
                                          onInputChange={(event, value, reason) => {
                                            if (reason == 'input') {
                                              GetPropertyList(value, 0);
                                            }
                                          }}
                                          getOptionLabel={(option) => option.full_name}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label='Right Holder/Partner'
                                              variant='outlined'
                                            />
                                          )}
                                        />
                                        <input
                                          type='text'
                                          name='properties_id'
                                          id='properties_id'
                                          value={properties_id}
                                          readOnly
                                          hidden
                                        />
                                        <div className='invalid-feedback'>
                                          {errors.properties_id}
                                        </div>
                                      </Grid>
                                    )}

                                    {visibilityBrandSelectEdit && (
                                      <Grid
                                        size={{
                                          lg: 12,
                                        }}
                                      >
                                        <Autocomplete
                                          id='brand'
                                          className='full-width'
                                          value={brand_arr_set}
                                          onChange={CommentBrandListChangeEdit}
                                          options={BrandList ? BrandList : []}
                                          onInputChange={(event, value, reason) => {
                                            if (reason == 'input') {
                                              GetBrandList(value, 0);
                                            }
                                          }}
                                          getOptionLabel={(option) => option.name}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label='Brand'
                                              variant='outlined'
                                            />
                                          )}
                                        />
                                        <input
                                          type='text'
                                          name='brand_id'
                                          id='cbrand_id'
                                          value={comment_brand_id}
                                          readOnly
                                          hidden
                                        />
                                        <div className='invalid-feedback'>
                                          {errors.comment_brand_id}
                                        </div>
                                      </Grid>
                                    )}

                                    <Grid
                                      size={{
                                        lg: 12,
                                      }}
                                    >
                                      <input
                                        accept='image/*'
                                        name='media_images'
                                        className=''
                                        disabled={view_edit_disable}
                                        id='contained-button-file'
                                        onChange={handleCaptureMedia}
                                        type='file'
                                      />

                                      <label htmlFor='contained-button-file'>
                                        <Button
                                          startIcon={<CloudUploadIcon color='secondary' />}
                                          variant='contained'
                                          component='span'
                                        >
                                          Upload
                                        </Button>
                                      </label>

                                      <Grid
                                        className='flex margin_top2'
                                        size={{
                                          lg: 12,
                                          sm: 12,
                                          xs: 12,
                                          md: 12,
                                        }}
                                      >
                                        {media_upload_array.map((row, i) =>
                                          row.file_type == 'image' ? (
                                            <div
                                              key={i}
                                              className='relative_div comment_preview_img'
                                            >
                                              <img
                                                className='preview'
                                                style={{
                                                  width: '100%',
                                                  height: '50px',
                                                  objectFit: 'fill',
                                                }}
                                                src={row.file_path}
                                                alt={row.file_s3_key}
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src = default_image;
                                                }}
                                              />
                                              <IconButton
                                                size='small'
                                                onClick={() => handleMediaDelete(i)}
                                                style={{
                                                  position: 'absolute',
                                                  right: '-10px',
                                                  top: '-10px',
                                                }}
                                                color='secondary'
                                              >
                                                <ClearIcon color='secondary' />
                                              </IconButton>
                                            </div>
                                          ) : (
                                            <div
                                              key={i}
                                              className='relative_div comment_preview_img'
                                            >
                                              {row.name}
                                              <IconButton
                                                size='small'
                                                onClick={() => handleMediaDelete(i)}
                                                style={{
                                                  position: 'absolute',
                                                  right: '-10px',
                                                  top: '-10px',
                                                }}
                                                color='secondary'
                                              >
                                                <ClearIcon color='secondary' />
                                              </IconButton>
                                            </div>
                                          ),
                                        )}
                                      </Grid>
                                    </Grid>

                                    <Grid
                                      className='text_right margin_top2'
                                      size={{
                                        lg: 12,
                                      }}
                                    >
                                      <Button
                                        color='secondary'
                                        onClick={() => visibilityEditCommentCancel(data.id)}
                                      >
                                        Cancel
                                      </Button>
                                      <Button
                                        variant='contained'
                                        disabled={submitted}
                                        onClick={() => handleUpdate(data.id)}
                                        type='button'
                                        color='secondary'
                                      >
                                        {(submitted && 'Please Wait') || (!submitted && 'Update')}
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </ListItem>
                              </div>
                            </form>
                          </div>
                        </div>
                      ))}
                  </List>

                  {visibilityCommentHistory && (
                    <div className='text_right margin_top2'>
                      <Button color='secondary' onClick={hideVisibilityCommentHistory}>
                        Back
                      </Button>
                    </div>
                  )}

                  {visibilityCommentHistory &&
                    HistoryList.map((row, i) => (
                      <div key={i} className='comment_card box_shadow nopadding relative_div'>
                        <ListItem alignItems='flex-start' style={{ flexWrap: 'wrap' }}>
                          <Grid container spacing={1}>
                            <Grid
                              size={{
                                lg: 12,
                              }}
                            >
                              {row.msg}
                            </Grid>

                            {row.comment ? (
                              <Grid
                                size={{
                                  lg: 12,
                                }}
                              >
                                {row.comment}
                              </Grid>
                            ) : (
                              ''
                            )}

                            {row.tags ? (
                              <Grid
                                size={{
                                  lg: 12,
                                }}
                              >
                                {row.tags.map((tag_new_name, key) => (
                                  <Chip key={key} label={tag_new_name} style={{ margin: '3px' }} />
                                ))}
                              </Grid>
                            ) : (
                              ''
                            )}

                            {row.property_name ? (
                              <Grid
                                size={{
                                  lg: 12,
                                }}
                              >
                                <Chip label={row.property_name} style={{ margin: '3px' }} />
                              </Grid>
                            ) : (
                              ''
                            )}

                            {row.brand_name ? (
                              <Grid
                                size={{
                                  lg: 12,
                                }}
                              >
                                <Chip label={row.brand_name} style={{ margin: '3px' }} />
                              </Grid>
                            ) : (
                              ''
                            )}

                            {row.tiles ? (
                              <Grid
                                size={{
                                  lg: 12,
                                }}
                              >
                                {row.tiles.map((tiles_name, key) => (
                                  <Chip key={key} label={tiles_name} style={{ margin: '3px' }} />
                                ))}
                              </Grid>
                            ) : (
                              ''
                            )}

                            {row.documents ? (
                              <Grid
                                size={{
                                  lg: 12,
                                }}
                              >
                                {row.documents.map((data_get, key) => (
                                  <div key={key} className='comment_share_section'>
                                    <DownloadLink
                                      label={data_get.name}
                                      filename={data_get.name}
                                      exportFile={() =>
                                        Promise.resolve(getDataFromURL(data_get.file_path))
                                      }
                                    />
                                  </div>
                                ))}
                              </Grid>
                            ) : (
                              ''
                            )}

                            <Grid
                              size={{
                                lg: 12,
                              }}
                            >
                              {row.date_time}
                            </Grid>
                          </Grid>
                        </ListItem>
                      </div>
                    ))}
                </Scrollbars>

                {visibilityAddComment && (
                  <form
                    id='addcomment'
                    className='add_commant_form'
                    encType='multipart/form-data'
                    autoComplete='off'
                  >
                    <div className='comment_card box_shadow nopadding relative_div'>
                      <ListItem alignItems='flex-start' style={{ flexWrap: 'wrap' }}>
                        <Grid container spacing={1}>
                          <Grid
                            size={{
                              lg: 12,
                            }}
                          >
                            <TextareaAutosize
                              style={{
                                width: '88%',
                                background: 'transparent',
                                marginTop: '0.5rem',
                              }}
                              name='comments'
                              className='custom_textarea'
                              aria-label='minimum height'
                              minRows={2}
                              placeholder='Comments *'
                            />
                            <div className='invalid-feedback'>{errors.comments}</div>
                          </Grid>
                          <Grid
                            size={{
                              lg: 12,
                            }}
                          >
                            <Autocomplete
                              multiple
                              id='tags'
                              className='full-width'
                              onChange={TagChange}
                              options={TagList ? TagList : []}
                              getOptionLabel={(option) => option.name}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onKeyDown={_handleKeyDown}
                                  label='Tags'
                                  variant='outlined'
                                />
                              )}
                            />
                            <div className='invalid-feedback'>{errors.tags}</div>
                            <input type='text' name='tags' value={tags} hidden readOnly />

                            {keyword_tag.map((row, i) => (
                              <Chip
                                key={i}
                                label={row.name}
                                deletevalue={i}
                                onDelete={() => DeleteTag(i)}
                              />
                            ))}
                          </Grid>

                          <Grid
                            size={{
                              lg: 12,
                            }}
                          >
                            <Autocomplete
                              multiple
                              id='tiles'
                              className='full-width'
                              onChange={TileChange}
                              options={TileList ? TileList : []}
                              getOptionLabel={(option) => option.name}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  onKeyDown={_handleKeyDown}
                                  label='Tiles'
                                  variant='outlined'
                                />
                              )}
                            />
                            <div className='invalid-feedback'>{errors.tags}</div>
                            <input type='text' name='tiles' value={tiles} hidden readOnly />

                            {keyword_tag.map((row, i) => (
                              <Chip
                                key={i}
                                label={row.name}
                                deletevalue={i}
                                onDelete={() => DeleteTag(i)}
                              />
                            ))}
                          </Grid>

                          {visibilityPropertySelect && (
                            <Grid
                              size={{
                                lg: 12,
                              }}
                            >
                              <Autocomplete
                                id='property'
                                className='full-width'
                                onChange={PropertyChange}
                                options={PropertyList ? PropertyList : []}
                                onInputChange={(event, value, reason) => {
                                  if (reason == 'input') {
                                    GetPropertyList(value, 0);
                                  }
                                }}
                                getOptionLabel={(option) => option.full_name}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label='Right Holder/Partner'
                                    variant='outlined'
                                  />
                                )}
                              />
                              <input
                                type='text'
                                name='properties_id'
                                id='properties_id'
                                value={properties_id}
                                readOnly
                                hidden
                              />
                              <div className='invalid-feedback'>{errors.properties_id}</div>
                            </Grid>
                          )}

                          {visibilityBrandSelect && (
                            <Grid
                              size={{
                                lg: 12,
                              }}
                            >
                              <Autocomplete
                                id='brand'
                                className='full-width'
                                onChange={CommentBrandListChange}
                                options={BrandList ? BrandList : []}
                                onInputChange={(event, value, reason) => {
                                  if (reason == 'input') {
                                    GetBrandList(value, 0);
                                  }
                                }}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                  <TextField {...params} label='Brand' variant='outlined' />
                                )}
                              />
                              <input
                                type='text'
                                name='brand_id'
                                id='brand_id'
                                value={comment_brand_id}
                                readOnly
                                hidden
                              />
                              <div className='invalid-feedback'>{errors.comment_brand_id}</div>
                            </Grid>
                          )}

                          <Grid
                            size={{
                              lg: 12,
                            }}
                          >
                            <input
                              accept='*'
                              name='media_images'
                              className=''
                              disabled={view_edit_disable}
                              id='contained-button-file'
                              onChange={handleCaptureMedia}
                              type='file'
                            />

                            <label htmlFor='contained-button-file'>
                              <Button
                                startIcon={<CloudUploadIcon color='secondary' />}
                                variant='contained'
                                component='span'
                              >
                                Upload
                              </Button>
                            </label>

                            <Grid
                              className='flex margin_top2'
                              size={{
                                lg: 12,
                                sm: 12,
                                xs: 12,
                                md: 12,
                              }}
                            >
                              {media_upload_array.map((row, i) =>
                                row.file_type == 'image' ? (
                                  <div key={i} className='relative_div comment_preview_img'>
                                    <img
                                      className='preview'
                                      style={{
                                        width: '100%',
                                        height: '50px',
                                        objectFit: 'fill',
                                      }}
                                      src={row.file_path}
                                      alt={row.file_s3_key}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = default_image;
                                      }}
                                    />
                                    <IconButton
                                      size='small'
                                      onClick={() => handleMediaDelete(i)}
                                      style={{
                                        position: 'absolute',
                                        right: '-10px',
                                        top: '-10px',
                                      }}
                                      color='secondary'
                                    >
                                      <ClearIcon color='secondary' />
                                    </IconButton>
                                  </div>
                                ) : (
                                  <div className='relative_div comment_preview_img' key={i}>
                                    {row.name}
                                    <IconButton
                                      size='small'
                                      onClick={() => handleMediaDelete(i)}
                                      style={{
                                        position: 'absolute',
                                        right: '-10px',
                                        top: '-10px',
                                      }}
                                      color='secondary'
                                    >
                                      <ClearIcon color='secondary' />
                                    </IconButton>
                                  </div>
                                ),
                              )}
                            </Grid>
                          </Grid>

                          <Grid
                            className='text_right margin_top2'
                            size={{
                              lg: 12,
                            }}
                          >
                            <Button color='secondary' onClick={handleToggleVisibilityAddComment}>
                              Cancel
                            </Button>
                            <Button
                              variant='contained'
                              disabled={submitted}
                              type='button'
                              onClick={handleSubmit}
                              color='secondary'
                            >
                              {(submitted && 'Please Wait') || (!submitted && 'Save')}
                            </Button>
                          </Grid>
                        </Grid>
                      </ListItem>
                    </div>
                  </form>
                )}

                {visibilityCommentList && visibilityAddComment == false && (
                  <div className='text_center margin_b'>
                    <Button
                      variant='contained'
                      color='secondary'
                      onClick={handleToggleVisibilityAddComment}
                    >
                      Add Comment
                    </Button>
                  </div>
                )}
              </div>
            </Card>
          </div>
        </div>
      )}
      {/* Compare form. */}
      {visibilityCompare && (
        <div className='compare_section' style={{ borderBottom: '1px solid' }}>
          <div className='margin_top margin_b2'>
            <Typography variant='h4' color='secondary'>
              Compare
            </Typography>
            <div
              className='close_comparebox'
              onClick={() => updateValue('visibilityCompare', false)}
            >
              <CloseIcon color='secondary' />
            </div>
          </div>
          <Grid container fixed='true' spacing={2}>
            {property_arr.map((PropertyValue, propertyIndex) => (
              <Grid
                key={propertyIndex}
                sx={{ position: 'relative' }}
                size={{
                  lg: 2,
                  md: 2,
                  sm: 3,
                }}
              >
                <Box
                  className='compare_blog relative_div'
                  id={'search_hide' + propertyIndex}
                  sx={{ height: '170px' }}
                >
                  <TextField
                    className='mobile_search_width header_search full-width'
                    onKeyUp={(event, value) => handleKeyUpProperty(event, value, propertyIndex)}
                    onFocus={() => setVisibleCompareOptionsIndex(propertyIndex)}
                    onBlur={() => setTimeout(() => setVisibleCompareOptionsIndex(false), 100)}
                    label='Search'
                    variant='outlined'
                    id={'remove_search_value' + propertyIndex}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='start'>
                          <IconButton color='secondary' size='large'>
                            <SearchIcon color='secondary' />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>

                <Box
                  className='compare_blog relative_div'
                  id={'selected_data' + propertyIndex}
                  style={{ display: 'none' }}
                  sx={{ height: '170px' }}
                >
                  <div className='delete_compare custom_avatardesign'>
                    <DeleteForeverIcon
                      sx={{ cursor: 'pointer' }}
                      onClick={() => removePropertyCompair(propertyIndex)}
                    />
                  </div>
                  <Avatar
                    variant='square'
                    id={'image_set' + propertyIndex}
                    src={
                      property_compair_arr[propertyIndex]
                        ? property_compair_arr[propertyIndex].profile_img
                        : ''
                    }
                  ></Avatar>
                  <div className='comp_description margin_top2'>
                    <Typography
                      variant='subtitle1'
                      color='secondary'
                      id={'full_name_set' + propertyIndex}
                    ></Typography>
                    <Typography
                      variant='subtitle2'
                      id={'category_set' + propertyIndex}
                    ></Typography>
                    <Typography
                      variant='subtitle2'
                      id={'property_type_set' + propertyIndex}
                    ></Typography>
                  </div>
                </Box>

                {Boolean(globalserachpropertyCompair.length > 0) &&
                  visibleCompareOptionsIndex === propertyIndex && (
                    <Grid
                      sx={{
                        position: 'absolute',
                        background: 'white',
                        maxHeight: '500px',
                        overflow: 'scroll',
                        border: '1px solid rgba(0, 0, 0, 0.23)',
                        borderTop: 'none',
                        transform: 'translateY(-110px)',
                        borderBottomRightRadius: '10px',
                        borderBottomLeftRadius: '10px',
                        maxWidth: 'calc(100% - 16px)',
                      }}
                    >
                      <Typography variant='h4' color='primary' sx={{ padding: '0 16px' }}>
                        Right Holder/Partner
                      </Typography>
                      <List className='search_list' style={{ cursor: 'pointer' }}>
                        {globalserachpropertyCompair.map((row, i) => (
                          <ListItem
                            key={i}
                            onClick={() => setPropertyCompair(row, propertyIndex)}
                            className='border_b custom_avatardesign'
                          >
                            <ListItemAvatar>
                              <Avatar src={row.profile_img}></Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={row.full_name}
                              secondary={row.category_name + ' | ' + row.property_type}
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Grid>
                  )}
              </Grid>
            ))}

            {/* Head-to-head needs a comparison key AND a head-to-head section key (part 7g). */}
            {canOpenPage('headToHead') && (
              <Grid
                size={{
                  lg: 2,
                  md: 2,
                  sm: 3,
                }}
              >
                <div className='compare_blog flex_center no_border'>
                  <Link
                    to={'/headtohead'}
                    className={
                      property_compair_arr.length > 1
                        ? 'text_decoration_none'
                        : 'text_decoration_none compair_btn_disable'
                    }
                  >
                    <Button
                      variant='contained'
                      color='secondary'
                      disabled={property_compair_arr.length > 1 ? false : true}
                      onClick={() => {
                        compairProperty();
                        updateValue('visibilityCompare', false);
                      }}
                    >
                      compare ({property_compair_arr.length})
                    </Button>
                  </Link>
                </div>
              </Grid>
            )}
          </Grid>
        </div>
      )}
      {visibilityCompare && (
        <div
          style={{
            position: 'fixed',
            width: '100%',
            height: '100vh',
            top: '0',
          }}
          onClick={() => updateValue('visibilityCompare', false)}
        ></div>
      )}
    </header>
  );
});

export default Header;
